import { Map, fromJS } from 'immutable';

export function request(state, { userId }) {
    return state.setIn([ 'assign-referred-betslip', userId ], Map({
        state: 'IN_PROGRESS'
    }));
}

export function error(state, { userId, errors }) {
    return state.setIn([ 'assign-referred-betslip', userId ], Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));
}

export function finish(state, { userId }) {
    return state.setIn([ 'assign-referred-betslip', userId ], Map({
        state: 'FINISHED',
        errors: void 0
    }));
}

export function clear(state, { userId }) {
    return state.removeIn([ 'assign-referred-betslip', userId ]);
}
